import DeliveryDeviceResult from 'generated/Result/Orders/Models/DeliveryDeviceResult';
import {
  GET_DELIVERY_DEVICES
} from '../types/order';
import { RESET_STATE } from '../types/global';

export interface OrderState {
  deliveryDevices: DeliveryDeviceResult[],
}

const INITIAL_STATE: OrderState = {
  deliveryDevices: null,
};

const orderReducer = function (state: OrderState = INITIAL_STATE, action): OrderState {
  switch (action.type) {
    case RESET_STATE:
      return INITIAL_STATE;
    case GET_DELIVERY_DEVICES:
      return { ...state, deliveryDevices: action.payload };
    default:
      return state;
  }
};

export default orderReducer;
